<button
    interacta-icon-button
    type="button"
    [icon]="'arrow-left'"
    [label]="'SHARED.BUTTON.GO_BACK' | translate"
    [size]="size()"
    (click)="back()"
></button>
